import { useCallback } from 'react';
import { Alert } from '@treezor/design-system';

import { refreshAccessToken } from '@/store/actions/auth.actions';

import { useAlert } from './useAlert';
import { timer } from './useAlerts';

export function LogoutReminder() {
  const { dispatch, t, handleAlertClose, alertClasses } = useAlert('logoutReminder');

  const handleRefreshToken = useCallback(() => {
    dispatch(refreshAccessToken());
    handleAlertClose();
  }, [dispatch, handleAlertClose]);

  return (
    <Alert
      title={t('components.molecules.logOutAlert.warning.label', { timer: timer / 60000 })}
      description={t('components.molecules.logOutAlert.warning.description')}
      isClosable
      variant="secondary"
      type="warning"
      onClose={handleAlertClose}
      className={alertClasses}
      action={{
        title: t('components.molecules.logOutAlert.warning.action'),
        onClick: handleRefreshToken,
      }}
    />
  );
}
